import { DELETE_REPORTED_ENTITY } from "../../../enums/Documents/DocumentsType";

export const reportEntityAction =(data) => {
    console.log("reportEntityAction: ", data);
    return {
        type: DELETE_REPORTED_ENTITY,
        payload:data,
    }
}
